import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '../../lib/utils';
import { waNavActive } from '../../pages/whatsapp/utils/whatsappUiTokens';

const NavItem = ({ to, onClick, icon, label, isActive, open = true, color, badge }) => {
  const base = "flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer w-full text-left";
  const activeClass = waNavActive;
  const inactiveClass = "text-gray-400 hover:text-white hover:bg-white/5";
  const style = color ? { color } : undefined;

  const BadgeComponent = badge > 0 ? (
    <span className={cn(
      "ml-auto px-2 py-0.5 text-[10px] font-bold rounded-full",
      isActive ? "bg-[hsl(160,84%,10%)] text-[hsl(158,45%,55%)]" : waNavActive
    )}>
      {badge > 99 ? '99+' : badge}
    </span>
  ) : null;

  if (to) {
    return (
      <Link to={to} className={cn(base, isActive ? activeClass : inactiveClass)} style={style}>
        <span className="h-5 w-5 flex items-center justify-center flex-shrink-0">{icon}</span>
        {open && <span className="flex-1">{label}</span>}
        {open && BadgeComponent}
      </Link>
    );
  }

  return (
    <button onClick={onClick} className={cn(base, inactiveClass)} style={style}>
      <span className="h-5 w-5 flex items-center justify-center flex-shrink-0">{icon}</span>
      {open && <span className="flex-1">{label}</span>}
      {open && BadgeComponent}
    </button>
  );
};

export default NavItem;